var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAsReferrerLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5239 7.73633L13.5513 8.70892C13.1867 9.07358 12.6515 9.61489 12.0933 10.167C12.4846 10.3036 12.8499 10.5295 13.1604 10.84C14.2798 11.9594 14.2798 13.7808 13.1604 14.9002L9.6802 18.3812C8.56039 19.5006 6.7386 19.5006 5.6192 18.3812C4.4998 17.2618 4.4998 15.4395 5.6192 14.3201L5.71774 14.2224C5.16111 12.9344 4.96986 11.5241 5.14091 10.1582C5.0638 10.2292 4.99698 10.3021 4.95104 10.3481L3.29908 12C0.900307 14.3988 0.900307 18.3025 3.29908 20.7013C5.69785 23.1 9.60155 23.1 12.0003 20.7013L15.4805 17.2211C17.8793 14.8223 17.8793 10.9186 15.4805 8.51985C15.1819 8.22082 14.8627 7.95988 14.5239 7.73633Z",
    fill: "#F2AE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.349 1.49951C14.7734 1.49951 13.1974 2.0995 11.998 3.29888L8.51783 6.77906C6.11906 9.17783 6.11906 13.0815 8.51783 15.4803C8.81644 15.7793 9.13558 16.0403 9.4744 16.2638L10.447 15.2912C10.8116 14.9266 11.3468 14.3853 11.9051 13.8331C11.5138 13.6966 11.1485 13.4707 10.8379 13.1602C9.71855 12.0408 9.71855 10.2194 10.8379 9.09998L14.3181 5.619C15.4379 4.4996 17.2597 4.4996 18.3791 5.619C19.4985 6.7384 19.4985 8.56061 18.3791 9.68001L18.2806 9.77775C18.8372 11.0657 19.0285 12.476 18.8574 13.842C18.9345 13.771 19.0013 13.698 19.0473 13.6521L20.6993 12.0001C23.098 9.60136 23.098 5.69766 20.6993 3.29888C19.4999 2.0995 17.9247 1.49951 16.349 1.49951Z",
    fill: "#02B27F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsReferrerLight);
export default __webpack_public_path__ + "static/media/as_referrer_light.2f643d66b62460513608caf59fd0e24b.svg";
export { ForwardRef as ReactComponent };